import React, { useContext } from 'react'
import { FormGroup, FormText, Input } from 'reactstrap'

export default function AiOverview({ context }) {
  const { aiOverview, setAiOverview } = useContext(context)

  return (
    <FormGroup>
      <label htmlFor="ai-overview" className="form-control-label">
        AI Overview Export
      </label>
      <div style={{ marginLeft: '+1.5em' }}>
        <Input
          className="form-control-alternative"
          type="checkbox"
          id="ai-overview"
          checked={aiOverview}
          style={{ width: 'auto' }}
          onChange={(e) => setAiOverview(e.target.checked)}
        />
        <FormText color="muted" align={'left'}>
          Spunta questa casella per attivare l'AI Overview export.
        </FormText>
      </div>
    </FormGroup>
  )
}